import { render, staticRenderFns } from "./PingAnTrunkBigPolicyEntry.vue?vue&type=template&id=2c44ec92&scoped=true"
import script from "./PingAnTrunkBigPolicyEntry.vue?vue&type=script&lang=js"
export * from "./PingAnTrunkBigPolicyEntry.vue?vue&type=script&lang=js"
import style0 from "./PingAnTrunkBigPolicyEntry.vue?vue&type=style&index=0&id=2c44ec92&prod&lang=less&scoped=true"
import style1 from "./PingAnTrunkBigPolicyEntry.vue?vue&type=style&index=1&id=2c44ec92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c44ec92",
  null
  
)

export default component.exports